/** Component page that displays the login details for the user to login to the demo site.
 */
import React from 'react';
import { Tooltip, Overlay } from 'react-bootstrap';
import Clipboard from 'react-clipboard.js';
import { FaClipboard, FaClipboardCheck } from 'react-icons/fa';

export default class ClipBoard extends React.Component {
    constructor() {
        super();
        this.state = {
            clicked: false
        }
        this.attachRef = target => this.setState({ target });
    }
    onClick = () => {
        this.setState({ clicked: true }, () => {
            setTimeout(() => {
                this.setState({ clicked: false })
            }, 2000);
        })
    }
    render() {
        const { clicked, target } = this.state;

        return <div style={{paddingTop: "5px"}}>
            <Clipboard component="a"
                button-title="Click to copy"
                className={clicked ? "btn btn-primary" : "btn btn-outline-primary"}
                data-clipboard-text={this.props.data}
                onSuccess={this.onClick}
                ref={this.attachRef}>
                {!clicked ? < FaClipboard /> : <FaClipboardCheck />}
            </Clipboard >
            <Overlay target={target} show={clicked} delay={{ show: 250, hide: 400 }}
                placement="bottom">
                {props => (
                    <Tooltip id="overlay-example" {...props}>
                        Copied to clipboard
            </Tooltip>
                )}
            </Overlay>
        </div>

    }
}


// WEBPACK FOOTER //
// ./src/components/components/ClipBoard.js